export const Color = [
  { 
    id: "Color 1", 
    title: "Color One", 
    color: "#FFB400" 
  },
  { 
    id: "Color 2", 
    title: "Color Two", 
    color: "#7FB800" 
  },
  { 
    id: "Color 3", 
    title: "Color Three", 
    color: "#FF99C8" 
  },
  { 
    id: "Color 4", 
    title: "Color Four", 
    color: "#F24333" 
  },
  { 
    id: "Color 5", 
    title: "Color Five", 
    color:  "#49B6FF" 
  },
];
  
  